import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { TranslateService } from '@ngx-translate/core';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-value',
  template: `
    <ng-container *ngIf="!to.copyToClipboard; else withCopy">
      <div [innerHTML]="formattedValue" class="col-form-label formly-value" [ngClass]="classNames"></div>  
    </ng-container>
    
    
    <ng-template #withCopy>
      <div class="row g-0">
        <div class="col">
          <div *ngIf="!to.copyToClipboardInlineValue" [innerHTML]="formattedValue" class="col-form-label formly-value" [ngClass]="classNames"></div>
          <input *ngIf="to.copyToClipboardInlineValue" class="form-control" [value]="formattedValue || ''" [formlyAttributes]="field" [type]="'text'" [readOnly]="true" [ngClass]="classNames">
        </div>
        
        <div class="col col-auto ms-auto copy-to-clipboard-wrapper">
          <copy-to-clipboard [value]="formattedValue || ''"></copy-to-clipboard>
        </div>
      </div>
    </ng-template>
  `
})
export class FormlyFieldValueComponent extends ExtraFieldType implements OnInit {
  public defaultOptions = {};
  public formattedValue:string;

  constructor(
    private translateService:TranslateService,
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.to.copyToClipboardInlineValue? this.formlyUtil.createClassNames(FormlyType.INPUT, <string>this.key, this.to.label) : this.formlyUtil.createClassNames(FormlyType.VALUE, <string>this.key, this.to.label);
    this.formattedValue = this.getFormattedValue(this.formControl.value);

    // register listener
    this.listen();
  }

  public getFormattedValue(value:any):string {
    const formatFn:Function = this.formlyUtil.getFormatFn(this.to.format);
    const formattedValue:string = formatFn(value);

    // do not translate the value when the field is not editable (eg. field "Key" from Edit label translation dialog)
    if (!this.to.editable) {
      return formattedValue;
    }

    try {
      return this.translateService.instant(formattedValue);
    } catch (e) {
      return formattedValue;
    }
  }

  protected listen():void {
    this.formControl.valueChanges
      .subscribe(value => {
        this.formattedValue = this.getFormattedValue(value);
      });
  }
}